import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.weak-map";
export var generateUID = function generateUID() {
  var counter = 1;
  var map = new WeakMap();

  var uid = function uid(item, index) {
    if (typeof item === 'number' || typeof item === 'string') {
      return index ? "idx-" + index : "val-" + item;
    }

    if (!map.has(item)) {
      map.set(item, counter++);
      return uid(item);
    }

    return 'uid' + map.get(item);
  };

  return uid;
};